module.exports = __webpack_public_path__ + "static/media/icon-caution.5962e7e2.svg";